// extracted by mini-css-extract-plugin
export default {"link":"AE-z","disabled":"BE-z"};